import * as Yup                 from    'yup';
import {
        PlaceOfSupply,
        GSTTreatment        }   from    '../../../../../common/common.model';
import { verifyGST } from '../../../../../common/common.service';


export default Yup.object({

    customer                    :   Yup.string()
                                    .required('Customer is required!')
                                    .notOneOf(['customerid'], 'Select a valid customer!'),

    number                      :   Yup.string()
                                    .required('Invoice number is required!'),

    date                        :   Yup.date()
                                    .required('Date is required!')
                                    .typeError('Date is not valid!'),

    billingAddress              :   Yup.string()
                                    .required('Billing address is required!'),

    vehicle                     :   Yup.string(),
    
    gstin                       :   Yup.string()
                                    .when("gstTreatment", {
                                        is: (value) => [GSTTreatment.Registered].includes(value),
                                        then: Yup.string().required('GSTIN is required!')
                                                            .test('gstin', 'GSTIN is not valid!', function(value: any) {
                                                                return new Promise((resolve, reject) => {
                                                                    if(value) {
                                                                        if(value.length === 15) {
                                                                            verifyGST(value).then((data: any) => resolve(data)).catch(_ => resolve(false))
                                                                        } else {
                                                                            resolve(false);
                                                                        }
                                                                    } else {
                                                                        resolve(true);
                                                                    }
                                                                })
                                                            }),
                                    }),

    gstTreatment                :   Yup.string()
                                    .required('GST Treatment is required!')
                                    .oneOf([GSTTreatment.Registered, GSTTreatment.Unregistered, GSTTreatment.None], 'GST Treatment is not valid!'),

    placeOfSupply               :   Yup.string()
                                    .required('Place of supply is required!')
                                    .oneOf([PlaceOfSupply.TN, PlaceOfSupply.KL, PlaceOfSupply.KN], 'Place of supply is not valid!')
})